module.exports = __webpack_public_path__ + "img/education-icon.5bb59c0c.png";